RivalIQ.apps.Reports.module('widgets', function (widgets, App, Backbone, Marionette, $, _) {

    'use strict';

    const Widget = RivalIQ.apps.Dashboard.models.Widget;
    const SectionalWidget = Widget.extend({
        getSlides: function () {
            const me = this;

            return new RivalIQ.apps.Reports.models.Slide({
                style: RivalIQ.enums.slideType.SECTIONAL,
                elements: {
                    head: me.getProp('title'),
                    square: true,
                    brand: RivalIQ.apps.Reports.models.Slide.brandImages.getLarge()
                }
            });
        },

        filter: function () {
            const me = this;
            return !RivalIQ.props.channelAccess(me.getProps());
        },
        // So we can load curations containing this widget on the page
        view: Backbone.View
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.SECTIONAL, SectionalWidget);
});
